import React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { TrainingMembershipFragment } from 'generated/resources/graphql'

import DropZone from 'modules/core/components/DropZone'
import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { acceptedContentTypes } from 'modules/core/lib/fileFormats'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useBulkCreateTrainingMembershipFiles } from 'modules/trainings/hooks/TrainingMembershipFiles/useBulkCreateTrainingMembershipFiles'

interface Props {
  navigateBackTo: string
  accessId: string
}
export const UploadCertificate = ({ navigateBackTo }: Props) => {
  const { access, company } = useCurrentSession()
  const { trainingMembership } = useOutletContext<{
    trainingMembership: TrainingMembershipFragment
  }>()

  const navigate = useNavigate()
  const navigateBack = () => {
    navigate(navigateBackTo)
  }

  const [file, setFile] = React.useState<File | undefined>(undefined)
  const onDropFile = (files: File[]) => {
    setFile(files[0])
  }

  const { uploadFiles } = useBulkCreateTrainingMembershipFiles()
  const onSubmit = async () => {
    if (!file) return
    if (!trainingMembership) return

    const result = await uploadFiles({
      files: [file],
      trainingMembershipId: trainingMembership.id,
      authorId: access.id,
      companyId: company.id,
    })

    const handled = handleResult(result, ({}) => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.session_access_membership_table.upload_files_error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.session_access_membership_table.upload_files_success'),
      })

      navigateBack()
    }
  }

  return (
    <Modal
      title={i18n.t('trainings.my_training.upload_certificate.upload')}
      description={i18n.t('trainings.my_training.upload_certificate.reviewed_description')}
      illustration="common-file-text-upload"
      onClose={navigateBack}
      onSubmit={onSubmit}
      footer={
        <Button disabled={!file || !trainingMembership} submit>
          {i18n.t('trainings.my_training.upload_certificate.upload_documents')}
        </Button>
      }
    >
      <Box gap="s24">
        {!file && (
          <DropZone
            onDrop={onDropFile}
            multiple={false}
            placeholder={i18n.t('trainings.my_training.upload_certificate.drop_file_description')}
            accept={acceptedContentTypes()}
          />
        )}
        {file && (
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Text.Normal>{file.name}</Text.Normal>
            <Button type="secondary" onClick={() => setFile(undefined)} iconName="delete" />
          </Box>
        )}
      </Box>
    </Modal>
  )
}
